export type AuthenticatedTabLaunchIntent = {
	kind: "browser-setup";
	assessmentId: string;
};

export function createAssessmentLaunchIntentConsumer(initialIntent?: AuthenticatedTabLaunchIntent) {
	let pendingIntent = initialIntent;
	return (intent: AuthenticatedTabLaunchIntent) => {
		const matches = pendingIntent?.kind === intent.kind && pendingIntent.assessmentId === intent.assessmentId;
		pendingIntent = undefined;
		return matches;
	};
}
